/**
 * Allowed prize-type values for admin create/edit flows (stored as `prize_type` text).
 * Tune per deployment/client — use stable machine values (no client prefix in the value;
 * this repo is already client-scoped).
 *
 * **The list must not be emptied.** It used to say an empty list fell back to a
 * free-text field; that was true only of `prize-tier-type-field.tsx`, the MUI
 * select the two full-page forms used, which CAE-1598 deleted along with them.
 * The one editor left draws `PrizeTypeCards` straight from this array, so an
 * empty list renders no cards and offers nothing in their place — and because
 * `validatePrizeTierDraft` requires a non-empty `prizeType`, no tier could be
 * created at all. (Editing an existing one would still work:
 * `mergePrizeTypeOptionForCurrentValue` puts the stored value back.) Adding a
 * type is safe; removing them all is not.
 */
export interface PrizeTierTypeOption {
  value: string;
  label: string;
}

export const PRIZE_TIER_TYPE_OPTIONS: readonly PrizeTierTypeOption[] = [
  { value: 'FREE_BET', label: 'Free bet' },
  { value: 'PROFIT_BOOST', label: 'Profit boost' },
  { value: 'BET_CREDIT', label: 'Bet credit' },
];

/** Ensures the current DB value appears in the select when it is not in config (legacy rows). */
export const mergePrizeTypeOptionForCurrentValue = (
  configured: PrizeTierTypeOption[],
  currentValue: string,
): PrizeTierTypeOption[] => {
  const trimmed = currentValue.trim();
  if (!trimmed || configured.some((o) => o.value === trimmed)) {
    return [...configured];
  }
  return [...configured, { value: trimmed, label: trimmed }];
};
